import React from "react";
import { buildLatestItemsSharedClasses } from "../external-data/shared/latest-items-ui";
import type { CardsSectionProps } from "../types";

function getCardCount(value?: string) {
  return value === "8" ? 8 : value === "6" ? 6 : value === "4" ? 4 : 3;
}

function getCardsRowClass(value?: string) {
  return value === "4" || value === "8"
    ? "row row-cols-1 row-cols-md-4 row-gap-5"
    : "row row-cols-1 row-cols-md-3 row-gap-5";
}

export function CardsSection(props: CardsSectionProps) {
  const {
    bgClass = "no-class",
    paddingYClass = "py-section-md",
    cardCount = "3",
    cardBgClass = "text-bg-white",
    cardBorderClass = "no-class",
    cardBorderColorClass = "no-class",
    contentAlignClass = "no-class",
    buttonColorClass = "primary",
    Card1,
    Card2,
    Card3,
    Card4,
    Card5,
    Card6,
    Card7,
    Card8,
  } = props;

  console.log("cardCount", cardCount);
  
  const visibleCards = [Card1, Card2, Card3, Card4, Card5, Card6, Card7, Card8].slice(0, getCardCount(cardCount));

  const classes = {
    ...buildLatestItemsSharedClasses({
      sectionClassName: "section-cards",
      bgClass,
      paddingYClass,
      cardBgClass,
      cardBorderClass,
      cardBorderColorClass,
      contentAlignClass,
      buttonColorClass,
    }),
    row: getCardsRowClass(cardCount),
  };

  return (
    <section className={classes.section || undefined}>
      <div className={classes.container}>
        <div className={classes.row}>
          {visibleCards.map((card, idx) => {
            if (!card) return null;

            const CardComponent = card.type as React.ComponentType<any>;
            return (
              <div key={idx} className={classes.col}>
                <CardComponent
                  {...card.props}
                  inheritedCardBgClass={cardBgClass}
                  inheritedCardBorderClass={cardBorderClass}
                  inheritedCardBorderColorClass={cardBorderColorClass}
                  inheritedContentAlignClass={contentAlignClass}
                  inheritedButtonColorClass={buttonColorClass}
                  matchHeight={true}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default CardsSection;